import { render, staticRenderFns } from "./IconPersonRight.vue?vue&type=template&id=7da5e066&"
import script from "./IconPersonRight.vue?vue&type=script&lang=js&"
export * from "./IconPersonRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports